import Label from './Label';

const NewFeatureLabel = () => <Label color="green">New</Label>;

export default NewFeatureLabel;
